import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { salon } from '../../data/content';
import { localIntroBlocks } from '../../data/localIntro';
import { shopLabels } from '../../data/shopLabels';
import { closingHeading, quietLink } from '../../ui/sections';
const LINK_CLASS = `group ${quietLink} text-ink`;

/**
 * Lokale introductie in drie leesbare blokken (voor wie zoekt op "schoonheidssalon {stad}").
 * Staat op Contact (docs/VORMGEVING.md §3); de homepage houdt "Kom langs"
 * met stad en adres, zodat de lokale vindbaarheid niet wegvalt.
 */
export function LocalIntro() {
  return <section className="bg-sand py-20 sm:py-24 lg:py-32" aria-labelledby="local-intro" data-id="element-7247" data-mp="20e7qw044w92m">
      <div className="mx-auto max-w-content px-6 lg:px-10" data-id="element-7248" data-mp="1veczzwkczjhk">
        <h2 id="local-intro" className={`max-w-2xl ${closingHeading} text-ink`} data-id="element-7249" data-mp="1vh7hbf82so6r">
          De duurzame schoonheidssalon van
          <span className="italic text-clay" data-id="element-7250" data-mp="25dav5icaib9j"> {salon.city}</span>
        </h2>

        <ul className="mt-12 grid gap-10 md:grid-cols-3 md:gap-8 lg:gap-12" data-id="element-7251" data-mp="25b7ve6lc53rm">
          {localIntroBlocks().map(b => <li key={b.title} className="flex flex-col border-t border-ink/15 pt-6" data-id="element-7252" data-mp="2i6ah65xx34cd">
              <h3 className="font-display text-xl leading-snug text-ink" data-id="element-7253" data-mp="2m85e6y8tevkc">{b.title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-muted" data-id="element-7254" data-mp="2mai3jwgwk87f">{b.body}</p>
              <div className="mt-auto pt-4" data-id="element-7255" data-mp="2r55jv81r5wax">
                {'to' in b.link ? <Link to={b.link.to} className={LINK_CLASS} data-id="element-7256" data-mp="2w5tk8kbvfpht">
                    {b.link.label}
                    <Arrow data-id="element-7257" data-mp="313v4v9oy3wve" />
                  </Link> : <a href={b.link.href} target="_blank" rel="noopener noreferrer" className={LINK_CLASS} data-id="element-7258" data-mp="35x7fgfwsi355">
                    {b.link.label}
                    <Arrow data-id="element-7259" data-mp="39zua0okui261" />
                    <span className="sr-only" data-id="element-7260" data-mp="3ex2x93kuowe5">{shopLabels.viaWhatsApp}</span>
                  </a>}
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}
function Arrow() {
  return <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-soft group-hover:translate-x-0.5" strokeWidth={1.5} aria-hidden="true" data-id="element-7261" data-mp="1jupo56bbg56j" />;
}